import { render, staticRenderFns } from "./ClaimSelect.vue?vue&type=template&id=17d33a23&"
import script from "./ClaimSelect.vue?vue&type=script&lang=js&"
export * from "./ClaimSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports